<script lang="ts">
  import { cn } from '$lib/utils';
  import { getImageAttributes } from '$lib/utils/cms';
  import type { LogosStoryblok } from '$types/bloks';
  import Image from './../image.svelte';
  import { t } from '$lib/i18n';
  import { buildSrcSet } from '$lib/image';

  export let block: LogosStoryblok;
</script>

<section class="px-2 lg:px-8 !py-0">
  <div class="container mx-auto">
    <h2 class="w-full text-3xl font-semibold mt-[88px] px-2 lg:text-center">{$t('logos.title')}</h2>
    <div
      class={cn(
        'flex gap-2 lg:gap-4 lg:mt-8 py-8 flex-wrap',
        block.logos.length < 4 && 'lg:justify-center'
      )}
    >
      {#each block.logos as logo}
        <!-- It would be better to use flex-basis instead of setting the width like this, however flex-basis doesn't take into consideration the flex gap -->
        <div
          class="w-[calc(50%-4px)] lg:w-[calc(25%-12px)] bg-white rounded-md overflow-hidden h-30 lg:h-40 shrink-0"
        >
          <Image
            class="h-full w-full object-contain"
            loading="eager"
            {...getImageAttributes(logo.asset)}
            srcset={buildSrcSet({
              loader: ({ width }) => getImageAttributes(logo.asset, { size: [width, 0] }).src,
              widths: [320, 640]
            })}
          />
        </div>
      {/each}
    </div>
  </div>
</section>
